import * as React from 'react'

type AnyEvent = MouseEvent | TouchEvent

export function useOnClickOutside(
  refs: React.RefObject<HTMLElement | null>[],
  onClickOutside: (event: AnyEvent) => void,
): void {
  const handleOutside = React.useEffectEvent((event: AnyEvent) => {
    if (refs.length === 0) {
      return
    }

    const isEventOutside = refs.every((ref) => {
      const element = ref?.current
      return !(!element || element.contains(event.target as Node))
    })

    if (isEventOutside) {
      onClickOutside(event)
    }
  })

  React.useEffect(() => {
    document.addEventListener(`mousedown`, handleOutside)
    document.addEventListener(`touchstart`, handleOutside)

    return () => {
      document.removeEventListener(`mousedown`, handleOutside)
      document.removeEventListener(`touchstart`, handleOutside)
    }
  }, [])
}
